/**
 * React Router v6 → v7 opt-in flags, shared by the app router and the test routers.
 *
 * Every router in the codebase passes this object so app and tests resolve routes the
 * same way, and so the v6 deprecation warnings stay off the console.
 *
 * - `v7_startTransition`: router state updates are wrapped in `React.startTransition`.
 * - `v7_relativeSplatPath`: relative paths inside splat (`*`) routes resolve against the
 *   matched parent rather than the full splat. Inert here — every element rendered under
 *   a splat route (`routeGuards.jsx` legacy redirects, `ErrorPage`) navigates absolutely.
 */
export const ROUTER_FUTURE_FLAGS = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
};
